<template>
<div id="app">
  <router-view />
</div>
</template>
<script>
  window.g={
    host :'https://wb.jzlmwl.com/',
    api:'https://wb.jzlmwl.com/dianti/api/',
    vercodeUrl:'https://wb.jzlmwl.com/captcha'
  }
</script>
